import { connect } from 'react-redux';
import MappingView from '../../../components/mappingView/MappingView';
import { setSnackAlert } from 'core/slices/snackAlert';
import {
  getMappingJobs,
  postMappingJob,
  deleteMappingJob,
  patchMappingJob,
  getBucketMapJobImg,
} from 'core/slices/mappingJobs';
import {
  getLocalBucketMapLayout,
  getMappingJobsList,
  isLoadingMappingJobsList,
  getLocalAvailableStores,
  getLocalAvailableFloors,
  isLoadingAvailableStores,
  isLoadingAvailableFloors,
  isLoadingBucketMapLayout,
  postMappingJobResponse,
  isLoadingPostMappingJob,
  getDeleteJobResponse,
  isLoadingDeleteJob,
  getJobUpdateResponse,
  isLoadingJobUpdate,
  getLocalRobotLayout,
  isLoadingRobotLayout,
  getJobImg,
  isLoadingJobImg,
} from 'core/selectors';
import {
  getAvailableFloors,
  getAvailableStores,
  getBucketMapLayout,
  getRobotLayout,
} from 'core/slices/layouts';

export default connect(
  (state) => ({
    mappingJobsList: getMappingJobsList(state),
    loadingMappingJobs: isLoadingMappingJobsList(state),
    bucketMapLayout: getLocalBucketMapLayout(state),
    availableStoresDict: getLocalAvailableStores(state),
    isLoadingAvailableStores: isLoadingAvailableStores(state),
    availableFloorsList: getLocalAvailableFloors(state),
    isLoadingAvailableFloors: isLoadingAvailableFloors(state),
    isLoadingBucketMapLayout: isLoadingBucketMapLayout(state),
    postMappingJobResponse: postMappingJobResponse(state),
    isLoadingPostMappingJob: isLoadingPostMappingJob(state),
    deleteJobResponse: getDeleteJobResponse(state),
    isLoadingDeleteJob: isLoadingDeleteJob(state),
    jobUpdateResponse: getJobUpdateResponse(state),
    isLoadingJobUpdate: isLoadingJobUpdate(state),
    robotLayout: getLocalRobotLayout(state),
    isLoadingRobotLayout: isLoadingRobotLayout(state),
    jobMapImg: getJobImg(state),
    isLoadingJobImg: isLoadingJobImg(state),
  }),
  {
    setSnackAlert,
    getMappingJobs,
    getBucketMapLayout,
    getRobotLayout,
    getAvailableStores,
    getAvailableFloors,
    postMappingJob,
    deleteMappingJob,
    patchMappingJob,
    getBucketMapJobImg,
  }
)(MappingView);
